import React, { type ComponentType } from 'react';
import { useAllTasksCompleted } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import { usePreviousWithInitial } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { JswOnboardingChecklist } from '@atlassian/jira-software-onboarding-quickstart/src/ui/async.tsx';
import { shouldRouteShowQuickstartOnboarding } from '../../utils.tsx';
import { OnboardingConfettiAsync } from './onboarding-confetti/async.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RightSidebars: ComponentType<Record<any, any>> = () => {
	const route = useCurrentRoute();
	const [allTasksCompleted] = useAllTasksCompleted();

	const previousAllTasksCompleted = usePreviousWithInitial(allTasksCompleted);

	if (!shouldRouteShowQuickstartOnboarding(route.name)) {
		return null;
	}
	return (
		<>
			{allTasksCompleted === true && previousAllTasksCompleted === false && (
				<OnboardingConfettiAsync />
			)}
			<JswOnboardingChecklist />
		</>
	);
};

export default RightSidebars;
